import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider, FieldArray, getIn } from 'formik';
import { connect } from "react-redux";
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
    Card,
    Stack,
    TextField,
    Container,
    Typography,
    Grid,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { createReProcessing } from '../../actions/reProcessingAction';
import _, { replace } from 'lodash';
import Page from '../../components/Page';
import { styled } from '@mui/material/styles';


// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 680,
    margin: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
}));

function CreateReProcessing(props) {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [adminObj, setAdminObj] = useState({});
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);

    const AddSchema = Yup.object().shape({
        auctioneer_name: Yup.string().required('Name is required'),
        po_box: Yup.string().required('Po Box no is required'),
        address: Yup.string().required('Address is required'),
        auctioneer_fee: Yup.number().positive().min(1,"Fee should be greater than 0").required('Fee is required'),
    });

    const formik = useFormik({
        initialValues: {
            car_detail_id:'',
            auctioneer_name: '',
            po_box: '',
            address: '',
            auctioneer_fee: ''
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            values.car_detail_id = props.carObj.carObj.id;
            props.createReProcessing(values);
        }
    });

    useEffect(() => {
        setIsLoading(false);
        if(props.alerts.status == 'success') {
            props.onDismis();
            navigate('/dashboard/reprocessings', { replace: true });
        }
    }, [props.alerts]);

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, handleChange, handleBlur } = formik;

    return (
        <Page title="Add Car Detail">
            <Container maxWidth="lg">
                <Card sx={{padding:"1em"}}>
                    <Grid container spacing={2} sx={{marginBottom:"30px"}}>
                        <Grid item xs={6}>
                            <b>Buyer Name:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.buyer_name}
                        </Grid>
                        <Grid item xs={6}>
                            <b>Buyer Telephone:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.telephone}
                        </Grid>
                        <Grid item xs={6}>
                            <b>Car Name:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.motor}
                        </Grid>
                        <Grid item xs={6}>
                            <b>Chasis No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.chasis_no}
                        </Grid>
                        <Grid item xs={6}>
                            <b>Engine No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.engine_no}
                        </Grid>
                        <Grid item xs={6}>
                            <b>Registration No:</b> {!_.isEmpty(props.carObj.carObj) && props.carObj.carObj.reg_no}
                        </Grid>
                    </Grid>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Typography gutterBottom>
                                            <b>Auctioneer Name</b>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Name*"
                                            {...getFieldProps('auctioneer_name')}
                                            error={Boolean(touched.auctioneer_name && errors.auctioneer_name)}
                                            helperText={touched.auctioneer_name && errors.auctioneer_name}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography gutterBottom>
                                            <b>Auctioneer Po Box</b>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Po Box*"
                                            {...getFieldProps('po_box')}
                                            error={Boolean(touched.po_box && errors.po_box)}
                                            helperText={touched.po_box && errors.po_box}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography gutterBottom>
                                            <b>Auctioneer Address</b>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Address*"
                                            {...getFieldProps('address')}
                                            error={Boolean(touched.address && errors.address)}
                                            helperText={touched.address && errors.address}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography gutterBottom>
                                            <b>Auctioneer Fee</b>
                                        </Typography>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            label="Fee*"
                                            {...getFieldProps('auctioneer_fee')}
                                            error={Boolean(touched.auctioneer_fee && errors.auctioneer_fee)}
                                            helperText={touched.auctioneer_fee && errors.auctioneer_fee}
                                        />
                                    </Grid>
                                </Grid>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                            </Stack>

                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right"}}
                            >
                                Add
                            </LoadingButton>
                        </Form>
                    </FormikProvider>
                </Card>
            </Container>
        </Page>
    );
}
const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        alerts: state.alerts,
    }
}

export default connect(mapStateToProps, { createReProcessing })(CreateReProcessing);

